module.exports = __webpack_public_path__ + "img/item_fw.3d6fbf91.png";